<template>
  <article class="base-modal" @mouseup="handleModalCloseClick" @touchend.prevent="handleModalCloseClick">
    <div class="base-modal__dialog" @mouseup.stop @touchend.stop>
      <div class="base-modal__contents">
        <header class="base-modal__header">
          <i18n-t keypath="title.admin_login" tag="h1" class="base-modal__title">
            <template #login>
              <span>{{ t('title.login') }}</span>
            </template>
          </i18n-t>
        </header>
        <div class="base-modal__body">
          <div class="keypad__description">{{ t('label.input_password') }}</div>
          <div class="keypad__display">
            <div class="display__dot">{{ password.length >= 1 ? '●' : '' }}</div>
            <div class="display__dot">{{ password.length >= 2 ? '●' : '' }}</div>
            <div class="display__dot">{{ password.length >= 3 ? '●' : '' }}</div>
            <div class="display__dot">{{ password.length >= 4 ? '●' : '' }}</div>
          </div>
          <div class="keypad">
            <BaseKeypad v-model="password" :max-length="4" />
          </div>
        </div>
        <footer class="base-modal__footer">
          <div class="footer__button">
            <BaseButton class="outline" @button-click="handleModalCloseClick">
              <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="25.075" height="25.075" viewBox="0 0 25.075 25.075">
                  <path
                    fill="#ffffff"
                    d="M24.258,100.207a2.509,2.509,0,1,0-3.548-3.548l-8.247,8.255L4.207,96.667a2.509,2.509,0,1,0-3.548,3.548l8.255,8.247L.667,116.718a2.509,2.509,0,1,0,3.548,3.548l8.247-8.255,8.255,8.247a2.509,2.509,0,1,0,3.548-3.548l-8.255-8.247Z"
                    transform="translate(0.075 -95.925)"
                  />
                </svg>
              </template>
              {{ t('button.cancel') }}
            </BaseButton>
          </div>
        </footer>
      </div>
      <div class="clock">
        <span>{{ clock }}</span>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
  import BaseButton from '@/components/base/BaseButton.vue';
  import BaseKeypad from '@/components/base/BaseKeypad.vue';
  import { useConfigStore } from '@/stores/config';
  import { useModalStore } from '@/stores/modal';
  import dayjs from 'dayjs';
  import { onMounted, ref, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';

  const { t } = useI18n();
  const router = useRouter();
  const configStore = useConfigStore();
  const modalStore = useModalStore();

  const password = ref('');
  const clock = ref('');

  onMounted(() => {
    setClock();
    setInterval(() => {
      setClock();
    }, 1000);
  });

  watch(password, () => {
    if (password.value.length === 4) {
      const today = new Date();
      let hour = today.getHours().toString();
      let minute = today.getMinutes().toString();
      hour = Number(hour) < 10 ? '0' + hour : hour;
      minute = Number(minute) < 10 ? '0' + minute : minute;

      if (password.value === hour + minute || password.value === configStore.config.ResellerDevicePassword) {
        router.replace('/admin');
        modalStore.closeAdminAuthModal();
      } else {
        password.value = '';
      }
    }
  });

  const handleModalCloseClick = () => {
    modalStore.closeAdminAuthModal();
  };

  const setClock = () => {
    clock.value = dayjs().format('YYYY-MM-DD HH:mm:ss');
  };
</script>

<style scoped lang="scss">
  .base-modal__dialog {
    position: relative;
    width: 80vw;
    height: auto;
    max-height: calc(100% - 2.9851vw);
    overflow-y: auto;
    .base-modal__contents {
      padding: 4.4776vw;
      .base-modal__header {
        display: flex;
        justify-content: center;
        border: none;
        .base-modal__title {
          font-size: 3.7313vw;
          span {
            color: #d7201a;
          }
        }
      }

      .base-modal__body {
        display: flex;
        flex-direction: column;
        align-items: center;
        .keypad__description {
          font-size: 2.0896vw;
        }
        .keypad__display {
          display: flex;
          gap: 1.4925vw;
          margin-bottom: 1.4925vw;
          .display__dot {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 5.9701vw;
            height: 5.9701vw;
            border-bottom: 0.2985vw solid #000;
            font-size: 2.0896vw;
            color: var(--brand-primary);
          }
        }
        .keypad {
          width: 37.3134vw;
        }
      }

      .base-modal__footer {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        margin-top: 2.9851vw;
        .footer__button {
          width: 18.6567vw;
        }
      }
    }
    .clock {
      position: absolute;
      bottom: 0.7463vw;
      right: 0.7463vw;
      span {
        font-size: 1.2687vw;
      }
    }
  }
</style>
